import axios from 'axios';


function updateConfig(config) {
    let cfg = {...config};
    cfg['headers'] = {
        ...cfg['headers'],
        'Cache-Control': 'no-cache',
    };
    axios.interceptors.request.use(function (config) {
        const token = JSON.parse(localStorage.getItem('token'))
        if (token != null && token !== "") {
            config.headers.Authorization = token.token_type + ' ' + token.id_token
        }
        return config;
    });
    return cfg;
}

export async function getRequest(url, config, resolve, reject) {
    try {
        return axios.get(url, updateConfig(config))
            .then(response => resolve(response))
            .catch(err => reject(err));
    } catch (err) {
        reject(err);
    }
}

export async function postRequest(url, config, data, resolve = () => {}, reject = () => {}) {
    try {
        return axios.post(url, data, updateConfig(config))
            .then(response => resolve(response))
            .catch(err => reject(err));
    } catch (err) {
        reject(err);
    }
}

export async function patchRequest(url, config, data, resolve = () => {}, reject = () => {}) {
    try {
        return axios.patch(url, data, updateConfig(config))
            .then(response => resolve(response))
            .catch(err => reject(err));
    } catch (err) {
        reject(err);
    }
}

export function getErrorMessage(err) {
    if (err === undefined) {
        return 'Something went wrong';
    }
    if (err.response === undefined || err.response.data === undefined) {
        return err.message ? err.message : 'Something went wrong';
    }
    return err.response.data;
}